/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleInfo, faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import './ModalFarmerProfileFilter.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getAllHpcCodesBySearch, getAllPlantCodes } from '../../store/modules/newUser/actions';
import {
  selectPlantCode, selectSearchedData,
} from '../../store/modules/newUser/selectors';
import Tooltip from '../Tooltip';

const ModalFarmerProfileFilter = ({
  show, toggle, onSubmit, values,
}) => {
  const dispatch = useDispatch();
  const currentDate = new Date(); // Get the current date
  const year = currentDate.getFullYear(); // Get the current year
  const startDate = new Date(year, 0, 1);
  const [fromDate, setfromDate] = useState(values ? new Date(values?.fromDate) : startDate.setMonth(startDate.getMonth() + 0, 1));
  const [toDate, setToDate] = useState(values ? new Date(values?.toDate) : new Date());
  const [dateError, setDate] = useState(null);
  const userRole = localStorage?.getItem('role');
  const plantCodeValues = useSelector((state) => selectPlantCode(state));
  console.log('selectPlantCode', plantCodeValues);
  // const hpcCodeValues = useSelector((state) => selectSearchedData(state));
  const showHideClassName = show ? 'edit-user-modal display-block' : 'edit-user-modal display-none';
  const {
    register, handleSubmit, setValue, formState: { errors },
  } = useForm();

  const fetchAllPlantCodes = () => {
    dispatch(getAllPlantCodes());
  };
  // const fetchAllHpcCodesForPlant = () => {
  //   const dataToBepassed = {
  //     type: 'plant',
  //   };
  //   dispatch(getAllHpcCodesBySearch(dataToBepassed));
  // };
  const roles = ['admin', 'regional_fa', 'regional_pi', 'ea_pi', 'call_center'];
  useEffect(() => {
    if (roles?.includes(userRole)) {
      fetchAllPlantCodes();
    } else {
      // fetchAllHpcCodesForPlant();
    }
  }, []);
  const handleOnPlantCodeSelected = (e) => {
    if (e?.target?.value !== 'Choose here') {
      const dataToBepassed = {
        type: 'admin',
        plantCode: e.target.value,
      };
      dispatch(getAllHpcCodesBySearch(dataToBepassed));
    }
  };
  const submit = ({
    plantCode,
    hpcCode,
  }) => {
    toggle();
    onSubmit({
      plantCode,
      hpcCode,
      fromDate,
      toDate,
    });
  };

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        <div className="row">
          <div className="col-12 d-flex end">
            <button type="button" className="modal-main__button" onClick={toggle}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="col-12">
            <div className="form">
              <div className="row">
                <div className="col-12 col-md-6">
                  {
                    roles?.includes(userRole) ? (
                      <div className="form__item">
                        <label htmlFor="quantity">
                          <div className="row middle">
                            <div className="col-12">
                              <span className="form__label">Plant Code</span>
                            </div>
                            <div className="col-12">
                              <select
                                id="plantCode"
                                name="plantCode"
                                onClick={handleOnPlantCodeSelected}
                                className="form__field"
                                {...register('plantCode', { required: { value: true, message: 'plantCode is required' } })}
                              >
                                <option hidden value="">Choose here</option>
                                {
                              plantCodeValues && plantCodeValues.filter((item) => item?.plateCode).map((item, index) => (
                                <option key={index.toString()} value={item?.plateCode}>{item?.plateCode}</option>
                              ))
                             }
                              </select>
                              {errors.plantCode && <div className="form__error">{errors.plantCode.message}</div>}
                            </div>
                          </div>
                        </label>
                      </div>
                    ) : null
                  }
                </div>
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="durarion">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">
                            From Date
                            {' '}
                            <Tooltip label={<FontAwesomeIcon icon={faCircleInfo} color="#bababa" size="xs" />} hoverText="By default, the date is set at +3 months from the fiscal year." />
                          </span>
                        </div>
                        <div className="col-12">
                          <DatePicker
                            selected={fromDate}
                            onChange={(date) => setfromDate(date)}
                            dateFormat="dd/MM/yyyy"
                            className="form__field"
                          />
                          {dateError && <div className="form__error">{dateError}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="durarion">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">To Date</span>
                        </div>
                        <div className="col-12">
                          <DatePicker
                            selected={toDate}
                            onChange={(date) => setToDate(date)}
                            dateFormat="dd/MM/yyyy"
                            className="form__field"
                          />
                          {dateError && <div className="form__error">{dateError}</div>}
                        </div>
                      </div>
                    </label>
                  </div>

                </div>
                <div className="col-12">
                  <div className="form__item">
                    <div className="row">
                      <div className="col-12 d-flex-col middle">
                        <button type="button" className="form__button" onClick={handleSubmit(submit)}>Filter</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ModalFarmerProfileFilter;
